import * as aor from "react-admin";
import React, { useState } from "react";
import CardActions from "@material-ui/core/CardActions";
import NewInstallationRunner from "../../components/NewInstallationRunner";
import TicketOwnership from "../../components/TicketOwnership";
import DeleteButton from "../../components/DeleteButton";
import Button from "@material-ui/core/Button";
import { Field } from "redux-form";
import { POLICY_TICKETS } from "../../common/rolesManagement";
import { getPolicies } from "../../common/authClient";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import myRestClient from "../../common/restClient";
import TranslatedText from "../../components/TranslatedText";
import { getCompany, getCustomer } from "../../common/utilities";

const MyToolbar = props => {
    const [open, setOpen] = useState(false);
    const [esito, setEsito] = useState("");
    const [loading, setLoading] = useState(false);

    async function checkLicenses(record) {
        const installation_type_id = record.installation_type_id;
        let company_vat = "";
        let customer_vat = "";
        await getCompany(record.company_id).then(company_detail => {
            company_vat = company_detail.vatin;
        });
        await getCustomer(record.customer_id).then(customer_detail => {
            customer_vat = customer_detail.vatin;
        });
        const result = await myRestClient("LICENSE_CHECK", "licenses_check", {
            data: {
                company_vat: company_vat,
                customer_vat: customer_vat,
                installation_type_id: installation_type_id
            }
        }).then(
            response => {
                if (response.data) return response.data;
                else return null;
            },
            err => {
                console.log(err);
                return null;
            }
        );
        return result;
    }

    const handleCheckLicenses = () => {
        // chiamata api per verificare le licenze
        setLoading(true);
        setOpen(true);
        checkLicenses(props.record)
            .then(result => {
                setEsito(
                    result.message.success
                        ? "Licenza attiva"
                        : result.message.error
                );
                setLoading(false);
            })
            .catch(error => {
                setEsito("Errore durante la verifica della licenza");
                setLoading(false);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <aor.Toolbar {...props}>
            <aor.SaveButton
                redirect={false}
                submitOnEnter={true}
                disabled={props.pristine}
                refresh={true}
            />
            <div style={{ marginLeft: "10px" }}>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCheckLicenses}
                >
                    <TranslatedText resource_name="resources.tickets.actions.check_license" />
                </Button>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={"xs"}
                >
                    <DialogTitle id="alert-dialog-title">
                        <TranslatedText resource_name="resources.tickets.actions.check_license" />
                    </DialogTitle>
                    <DialogContent>
                        {loading ? (
                            <div align="center">
                                <CircularProgress size={18} thickness={2} />
                            </div>
                        ) : (
                            <DialogContentText id="alert-dialog-description">
                                {esito}
                            </DialogContentText>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            <TranslatedText resource_name="ra.actions.close" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </aor.Toolbar>
    );
};
const Actions = ({ permissions, basePath, data }) => {
    return (
        <CardActions
            style={{ zIndex: 2, display: "inline-block", float: "right" }}
        >
            {//DeleteButton is visible only when a ticket is ToDo
            data &&
                (data.is_deletable || !data.user_id) &&
                permissions &&
                permissions.includes(POLICY_TICKETS.DELETE) && (
                    <DeleteButton
                        text={"Cancella"}
                        dialogContentTitle={"Cancella"}
                        undoable={false}
                        basePath={basePath}
                        record={data}
                        resource="tickets"
                        message={"Ticket eliminato"}
                        redirect="tickets"
                    />
                )}
            <aor.ListButton basePath={basePath} />
        </CardActions>
    );
};

export default props => (
    <aor.Edit
        {...props}
        undoable={false}
        actions={<Actions permissions={getPolicies()} />}
        title={"resources.tickets.nameSingular"}
    >
        <aor.SimpleForm toolbar={<MyToolbar />}>
            <NewInstallationRunner
                ticket_id={props.id}
                installation_id={props.installation_id}
            />
            <aor.ReferenceField
                source="customer_id"
                reference="customers"
                linkType="show"
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            <aor.ReferenceField
                source="company_id"
                reference="companies"
                linkType={true}
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            <aor.DateField
                source="created_at"
                showTime={true}
                options={{ hour12: false }}
            />
            {getPolicies().includes(POLICY_TICKETS.SHOW_OWNERSHIP) && (
                <Field {...props} name="user_id" component={TicketOwnership} />
            )}
            <aor.DateField
                source="assigned_at"
                showTime={true}
                options={{ hour12: false }}
            />
            <aor.DateField
                source="last_updated_status_at"
                showTime={true}
                options={{ hour12: false }}
            />
            <aor.TextField
                source="installation_type_label"
                label="resources.installations.fields.installation_type_id"
            />
            <aor.ReferenceField
                source="installation_id"
                reference="installations"
                linkType="show"
                allowEmpty
            >
                <aor.TextField source="access_url" />
            </aor.ReferenceField>
            <aor.TextField source="pdl" />
            <aor.LongTextInput source="note" />
        </aor.SimpleForm>
    </aor.Edit>
);



// WEBPACK FOOTER //
// ./src/resources/Tickets/Edit.js